import React from 'react';

export default function Terms() {
  return (
    <div className="bg-[#FAF8F5] min-h-screen text-[#2B1810] py-12">
      <div className="max-w-4xl mx-auto px-4 space-y-8 bg-white p-8 md:p-12 rounded-2xl border border-[#E8DFD8] shadow-sm">
        <div className="text-center space-y-2 border-b border-[#E8DFD8] pb-6">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#C49A45]">Terms of Service</span>
          <h1 className="font-heading text-3xl font-bold text-[#2B1810]">Terms & Conditions</h1>
          <p className="text-xs text-[#8A796C]">Effective Date: August 17, 2026</p>
        </div>

        <div className="space-y-6 text-xs leading-relaxed text-[#2B1810]">
          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">1. Agreement to Terms</h2>
            <p className="text-[#8A796C]">
              By accessing Chandana Aura, browsing our catalog, or placing an order, you agree to be bound by these Terms and Conditions.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">2. Product Authenticity & Handcrafting</h2>
            <p className="text-[#8A796C]">
              All sandalwood products (idols, malas, agarbatti, keychains) sold on Chandana Aura are handcrafted from legally sourced Karnataka & Mysuru sandalwood logs. Because each piece is carved individually by artisans from natural wood, natural variations in wood grain, color shading, and slight weight differences may occur.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">3. Pricing & Payments</h2>
            <p className="text-[#8A796C]">
              All prices listed on the website are in Indian Rupees (INR) inclusive of applicable taxes. We reserve the right to modify prices, discounts, or promo offers without prior notice.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-heading text-base font-bold text-[#2B1810]">4. Intellectual Property</h2>
            <p className="text-[#8A796C]">
              All content, brand logos, product designs, graphics, images, and text on Chandana Aura are the exclusive property of Chandana Aura Traders.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
